var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendemoji6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2791 47.2698C67.0647 56.2907 54.707 66.2574 44.29 66.2752C33.8373 66.2928 21.4995 56.4756 23.2309 47.1533L27.2889 46.9316L61.2732 46.8593L65.2791 47.2698ZM55.4948 36.8366C51.7188 29.416 57.7909 24.7145 62.4366 28.4466C66.5122 31.7203 64.8933 39.6247 55.4948 36.8366ZM33.0339 36.8034C23.4279 39.7492 22.0803 31.5525 26.0995 28.3944C30.7707 24.7241 36.6623 29.4438 33.0339 36.8034ZM87.6383 52.7829C92.651 25.7905 74.2312 5.35898 52.8572 0.954178C26.1707 -4.54562 5.22769 14.6243 0.955088 35.5871C-4.55121 62.6026 14.6388 83.352 35.7192 87.6459C62.2327 93.0462 83.7024 73.9767 87.6383 52.7829Z",
    fill: "#F2B51E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendemoji6);
export default __webpack_public_path__ + "static/media/friendemoji6.fd9164a657ff9f39077ffb8530793ab4.svg";
export { ForwardRef as ReactComponent };